import React from "react";
import { Box, styled } from "@mui/material";

import usePromotions from "../../hooks/usePromotions";

import PromotionCard from "../PromotionCard";

const Container = styled(Box)(({ theme }) => ({
  width: "calc(100vw - 32px)",

  display: "flex",
  gap: "20px",

  overflow: "scroll",

  scrollbarWidth: "none",
  "&::-webkit-scrollbar": {
    display: "none",
  },

  [theme.breakpoints.up("md")]: {
    width: "100%",
    flexWrap: "wrap",
  },
}));

export default function PromotionsCarousel({ cardVariant = "promotion" }) {
  const { promotions, isLoading } = usePromotions();

  if (isLoading) return <div>Loading...</div>;

  return (
    <Container>
      {promotions.map((promotion) => (
        <PromotionCard
          key={promotion.id}
          variant={cardVariant}
          promotion={promotion}
        />
      ))}
    </Container>
  );
}
